// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwComponentSectionConfigPreference, DevwareMetaDataService, DwQueryHelper, DwOrmDataServiceToken, DwOrmDataService, DwQuery, DwOrmData, DwEventTriggerTypeList, DwSecurityUserService, DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames, AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
import { NoteControlConfig } from '../models/note-control-config.model';
import { NoteControlConfigComponent } from './note-control-config/note-control-config.component';


@DwComponent({
  name: 'NoteControl',
  isGlobal: true,
  componentType: DwComponentType.formSection,
  configComponent: NoteControlConfigComponent
})
@Component({
  selector: 'app-note-control',
  templateUrl: './note-control.component.html',
  styleUrls: ['./note-control.component.scss']
})
export class NoteControlComponent
  extends DwSectionBaseComponent<DwComponentSectionConfigPreference<NoteControlConfig>> implements OnInit {

  comments: [{}] = [{}];
  Searchcomments: [{}] = [{}];
  NoteResults: DwOrmData[]
  isConfigComplete = false;
  moment: any = moment;
  noteControlConfig: NoteControlConfig;
  @ViewChild('comment') comment: ElementRef;
  closeResult: string;
  hasPermission = false;
  searchQuery: string;
  lastPkValue: any;
  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    private dwSecurityUserService: DwSecurityUserService,
    private modalService: NgbModal,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    @Inject(DwMetaDataFormStateService) private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private messageService: DwMessagingService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  ngOnInit() {

    super.ngOnInit();
    var newComments: [{}] = [{}];
    this.lastPkValue = null;
    this.noteControlConfig = this.sectionConfig.config;
     this.formGroup.statusChanges.subscribe(x => {
      if (this.dwMetaDataFormStateService.state.formContext.loadDataComplete){
       this.getKeyValue(this.formGroup.getRawValue()).then(pkValue => {

        if (this.noteControlConfig.SaveOnSwitch && this.lastPkValue != null && pkValue != this.lastPkValue) {
          this.addNoteToLastPk(this.comment.nativeElement.value)
          this.lastPkValue = pkValue;
          this.comments = [{}];
        }

        if (pkValue != null && pkValue != this.lastPkValue) {
          this.lastPkValue = pkValue;
          this.refreshComments();}
        }
      );
    }
  }
    );
    this.hasPermission = this.doTheyHaveDeletePermisson();
  }


  getComments(tableName: string, noteField: string, noteKey: string, fkValue: number) {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = new DwQuery(tableName)
    query.AddFilterAnd(qh.filters.Equal('IsDeleted', false))
    query.AddFilterAnd(qh.filters.Equal(noteKey, fkValue))
    query.FieldSettings.LoadAllLookupDisplayFields = true;
    query.OrderBy('CreatedByDateTime',false);
    const results = this.dataService.executeQuery(query);
    return results
  }
  refreshComments() {
    var newComments: [{}];
    var tableName = this.noteControlConfig.NoteTable;
    var noteField = this.noteControlConfig.NoteField;
    var noteFk = this.noteControlConfig.NoteKey;
    newComments = [{}]
    if (Array.isArray(newComments)) {
      newComments.forEach(x => newComments.pop())
    }
    this.getKeyValue(this.dwMetaDataFormStateService.state.formApi.getFormData()).then(pkValue => {
      this.getComments(tableName, noteField, noteFk, pkValue).subscribe(results => {
        results.forEach(result => {
          var newResult: any = result;
          newComments.push({ "id": newResult.NoteId, "Person": newResult.CreatedByEthos_UserIdDisplay, "Comment": newResult.Note, "date":  newResult.CreatedByDateTime});
            newComments.sort((a: any, b: any) => (a.date < b.date) ? 1 : -1);

        });

      })
    })
    this.comments = newComments;
    this.Searchcomments = newComments;
  }

  getKeyValue(data: any) {
    return this.dwMetaDataService.getMetaData(this.formConfig.rootItemName)
      .pipe(map(item => {
        let keyName = item.Attributes.find(a => a.IsKey).AttributeName;

        return data[keyName];
      })).toPromise().then(x => { return x });

  }

  getUser(trustId: number) {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.RoEthosUser.CreateQuery()
    query.AddFilterAnd(qh.filters.Equal(md.RoEthosUser.UserId, trustId))
    const results = this.dataService.executeQuery(query);
    return results;
  }

  doTheyHaveDeletePermisson() : boolean{
    var permissionNeeded = this.noteControlConfig.CanDeletePermissionMeaning;
    if (permissionNeeded == undefined || permissionNeeded == null){
      return false;
    }
    var HasPermisson : boolean = false;
    const user = this.dwSecurityUserService.securityContext.ApplicationUser;
    user.Permissions.forEach(x =>{
      if (x == permissionNeeded){
        HasPermisson = true;
      }
    })
    return HasPermisson;
  }


  getAttributeValue(attrName: string) {
    const control = this.formGroup.get(attrName);

    if (!control) {
      console.warn(`Attribute ${attrName} as not found in the form group!`);
      return `${attrName} not found`;
    }

    return control.value;
  }

  onAddNote(comment: string) {
    this.getKeyValue(this.formGroup.getRawValue()).then(keyValue => {
      var noteField = this.noteControlConfig.NoteField;
      var noteFk = this.noteControlConfig.NoteKey;

      var tableName = this.noteControlConfig.NoteTable;
      const template: any = this.dataService.createDummyEntity(tableName);

      template[noteFk] = keyValue;
      template[noteField] = comment;
      this.dataService.saveEntity(template).subscribe(x => {
        this.refreshComments();
      });

      this.comment.nativeElement.value = null;
    });
    return;

  }

  addNoteToLastPk(comment: string) {
      if (comment == '') return;
      var noteField = this.noteControlConfig.NoteField;
      var noteFk = this.noteControlConfig.NoteKey;

      var tableName = this.noteControlConfig.NoteTable;
      const template: any = this.dataService.createDummyEntity(tableName);

      template[noteFk] = this.lastPkValue;
      template[noteField] = comment;
      this.dataService.saveEntity(template).subscribe();

      this.comment.nativeElement.value = null;
      return;
  }

  trackNote(index: number, note: any) {
    return note.id;
  }

  deleteNote(id: number){
    console.log(id);


    var noteField = this.noteControlConfig.NoteField;
    var noteFk = this.noteControlConfig.NoteKey;

    var tableName = this.noteControlConfig.NoteTable;
    const template: any = this.dataService.createDummyEntity(tableName);

    template['NoteId'] = id;
    template['IsDeleted'] = true;
    //this.dataService.updateAttributeValue(template, 'IsDeleted', true).subscribe(x => {
    //  console.log(x);
    //});
    this.dataService.saveEntity(template).subscribe(x => {
      this.refreshComments();
    });

  }


  onDelete(id: number, content){
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      if (result == "Delete click"){
        this.deleteNote(id);
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  onSearch(searchQuery: string){
    this.searchQuery = searchQuery;




    /* this.comments.filter ({

    })
    }*/

    // this.comments.foreach(x => {
    //   if (!x.Comment contains searchQuery){
    //     this.comments.pop()
    //   }
    // })
    // if (searchQuery == null) {
    //   this.comments = this.Searchcomments;
    // }
    // this.comments searchQuery for the string
    // remove items that dont match the searchQuery
    // if the value of searchQuery is null then restore this.comments to its older self.

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}

